import { create } from 'zustand';
import { logAnalyticsEvent } from '@/services/analyticsLogger';

export type PremiumGateAnalyticsSource =
  | 'feature_gate'
  | 'upgrade_prompt'
  | 'trial_expired'
  | 'other'
  | 'profile_plan_card'
  | 'itinerary_fill_day'
  | 'itinerary_fill_day_limit'
  | 'itinerary_fill_day_auto_limit';

export type PremiumGatePayload = {
  feature: string;
  title?: string;
  message?: string;
  source?: PremiumGateAnalyticsSource;
  /** Optional primary-button label override for future modal layouts */
  cta?: string;
};

type PremiumGateState = {
  visible: boolean;
  feature?: string;
  title?: string;
  message?: string;
};

type PremiumGateActions = {
  open: (payload: PremiumGatePayload) => void;
  close: () => void;
};

export const usePremiumGateStore = create<PremiumGateState & PremiumGateActions>((set) => ({
  visible: false,
  feature: undefined,
  title: undefined,
  message: undefined,
  open: (payload) => {
    set({
      visible: true,
      feature: payload.feature,
      title: payload.title,
      message: payload.message,
    });

    // Best-effort analytics; don't block UI.
    logAnalyticsEvent('premium_paywall_shown', {
      source: payload.source ?? 'feature_gate',
      feature: payload.feature,
    }).catch(() => {});
  },
  close: () => set({ visible: false }),
}));

